import React from "react"
import CompetitionEditor from "./CompetitionEditor"
import CompetitionTabHeader from "./CompetitionTabHeader"

export default function CompetitionEditorRoute({ id, match, userDetails, getEventDetails, managementActions }) {
  return <>
    <CompetitionTabHeader title={match?.params?.competitionId ? "Details" : "Create competition"} />
    <CompetitionEditor eventId={id} competitionId={match?.params?.competitionId} userId={userDetails?.id || userDetails?._id}
      onSaved={getEventDetails} managementActions={managementActions} />
  </>
}
